module.exports = __webpack_public_path__ + "img/img7.7c36ba10.png";